import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, ListProductsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ListProductsResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

type Props = {
  onSuccess?: OnSuccessFn
}

const getProductsQueryKey = () => ["products"]

export const productsQuery = ({ onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getProductsQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/billing/products")
      onSuccess?.(data)
      return data.data
    },
  })
}
